import { addSelectRow, removeSelectRow } from "@global-state/pages/admin/customers/slice";
import { IUser } from "@interfaces/admin/user";
import { Checkbox } from "@ui";
import { useAppDispatch, useAppSelector } from "store/hooks";

export function CheckboxCell({
    data
}: {
    data: IUser
}) {
    const selectRows = useAppSelector(state => state.customersAdminPage.selectRows)

    const dispatch = useAppDispatch();

    return (
        <Checkbox
            checked={selectRows.includes(data.id)}
            onChange={() => {
                if (selectRows.includes(data.id)) {
                    dispatch(removeSelectRow(data.id))
                } else {
                    dispatch(addSelectRow(data.id))
                }
            }}
        />
    )
}